<ag-grid-angular class="ag-theme-material ag-grid-list w-full" rowSelection='multiple' [gridOptions]="gridOptions"
    [columnDefs]="columnDefs" [frameworkComponents]="frameworkComponents">
</ag-grid-angular>